<template>
  <div
    class="news-container"
    :style="{ backgroundColor: backgroundColor }"
  >
    <div
      class="news-header"
      :title="newsItemTitle"
    >
      {{ newsItemTitle }}
    </div>
    <div class="news-time">
      {{ newsTime }}
    </div>
    <div class="news-text">
      {{ newsItemText }}
    </div>
    <div class="news-source">
      <img
        class="news-source__icon"
        :src="require(`/public/img/source-image.jpeg`)"
        alt=""
      >
      <span>{{ t('country_pulse_news_view.source_title') }}:</span>
      <a
        class="source-link"
        :href="newsItem.url"
        target="_blank"
      >
        {{ newsItem.url }}
      </a>
    </div>
  </div>
</template>

<script>
// TODO: Перевести на script setup !

import { computed } from "vue";
import { t } from "@/controllerLK/AvalLocalization";
import { getTimeAgo } from "@/tools/date-time-tools";
import {importanceList} from "@/const/importance.list";
export default {
  name: "CountryPulseNewsView",
  props: {
    newsItem: {
      type: Object,
      required: true,
    }
  },
  setup(props) {

    const cutTags = (str) => {
      if(!str) {
        return "";
      }
      return str.replace(/( |<([^>]+)>)/ig, " ");
    };

    const backgroundColor = computed(() => {
      return importanceList[props.newsItem.importance].pulseColor;
    });
    const newsTime = computed(() => {
      return getTimeAgo(props.newsItem.date);
    });
    const newsItemTitle = computed(() => {
      return cutTags(props.newsItem.title);
    });
    const newsItemText = computed(() => {
      return cutTags(props.newsItem.raw_text);
    });
    return {
      backgroundColor,
      newsTime,
      newsItemTitle,
      newsItemText,
      t
    };
  },
};
</script>

<style lang="scss" scoped>
.news-container {
  // height: 207px;
  padding: 15px 20px;
  text-align: start;
  flex: 1;
  .news-header {
    font-family: Roboto, sans-serif;
    font-weight: 500;
    font-size: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    // height: 47px;
    line-height: 24px;
  }
  .news-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    font-size: 13px;
    margin-bottom: 10px;
    line-height: 22px;
  }

  .news-time {
    font-size: 12px;
    color: #808080;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .news-source {
    display: flex;
    gap: 5px;
    flex-wrap: nowrap;
    align-items: center;
    font-size: 14px;
    & span,a {
      font-size: 14px;
    }
    &__icon {
      flex: 0 0 21px;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      border: 1px solid #E7E7E7;
    }
  }
  .source-link {
    color: #1a64d4;
    display: block;
    overflow: hidden;
    text-wrap: nowrap;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
